/**
 * @generated SignedSource<<f42f1a468afad6ea0b1f078360ce213e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TrackerFilterQuery$variables = {
  search?: string | null;
};
export type TrackerFilterQuery$data = {
  readonly smartTrackers: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type TrackerFilterQuery = {
  response: TrackerFilterQuery$data;
  variables: TrackerFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "SmartTracker",
    "kind": "LinkedField",
    "name": "smartTrackers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TrackerFilterQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TrackerFilterQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "55f803809339cab1a284b50086bb738d",
    "id": null,
    "metadata": {},
    "name": "TrackerFilterQuery",
    "operationKind": "query",
    "text": "query TrackerFilterQuery(\n  $search: String\n) {\n  smartTrackers(search: $search) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "674fc0877c758dc9017422bdb8a443c6";

export default node;
